import actionTypes from '../actionTypes';
import _ from 'lodash';

const initialState = {
    isLoading: true,

    providers: {
        deliveryProvider: {
            hasChanges: true,
            isLoading: true,
            selectedSubscription: 0,
            selectedMetadata: {

            },
            actualSubscription: 0,
            actualMetadata: {

            },
            availableSubscriptions: [
                {
                    id: 0,
                    name: 'skip'
                }
            ],
            availableCapabilities: [

            ]
        }
    }
};


function updateProvider(action, state, updatedState) {
    const { type } = action.payload;
    const providerState = state.providers[type];
    return {
        ...state,
        providers: {
            ...state.providers,
            [type]: {
                ...providerState,
                ...updatedState(providerState)
            }
        }
    }
}

export default (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.SUBSCRIPTIONS_LOADED:
            const  { subscriptions, restaurantSubscriptions } = action.payload;
        console.error(subscriptions);

            const groupedSubscriptions = _.chain(subscriptions)
                .groupBy('subscriptionType')
                .mapValues(v => {
                    let selectedSubscription = restaurantSubscriptions.find(r => r.subscriptionType === v.subscriptionType);
                    let selectedId = selectedSubscription ? selectedSubscription.subscriptionId : null;
                    let metadata = selectedSubscription ? selectedSubscription.metadata : {};

                    return {
                        actualSubscription: selectedId,
                        selectedSubscription: selectedId,
                        actualMetadata: metadata,
                        selectedMetadata: metadata,
                        availableSubscriptions: [...v],
                        hasChanges: state.providers[v.subscriptionType]
                                    ? state.providers[v.subscriptionType].hasChanges
                                    : false,
                        isLoading: state.providers[v.subscriptionType]
                                   ? state.providers[v.subscriptionType].isLoading
                                   : false, //TODO: False
                    };
                })
                .mapValues(v => _.omit(v, 'subscriptionType'))
                .value();


            const subscriptionTypes = Object.keys(groupedSubscriptions);



            console.error(groupedSubscriptions, subscriptionTypes);

            return {
                ...state,
                isLoading: false,
                providers: {
                   ...state.providers,
                   ...groupedSubscriptions
                }
            };
        case actionTypes.RESTAURANT_SUBSCRIPTIONS_LOADING:
            return state;
        case actionTypes.RESTAURANT_SUBSCRIPTIONS_LOADED:


            return state;
        case actionTypes.RESTAURANT_SUBSCRIPTIONS_SELECT_PROVIDER:
            return updateProvider(action, state, () => ({
                hasChanges: true,
                selectedSubscription: action.payload.subscriptionId
            }));
        case actionTypes.RESTAURANT_SUBSCRIPTIONS_RESET:
            return updateProvider(action, state, (provider) => ({
                hasChanges: false,
                selectedSubscription: provider.actualSubscription,
                selectedMetadata: provider.actualMetadata
            }));
        default:
            return state;
    }
};




// WEBPACK FOOTER //
// /src/store/reducers/subscriptions.js